import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { apiGet } from 'tennders-stracture/libs/api'
import { StateType } from 'tennders-common/types/StateType'
import { dispatchInitials } from 'tennders-common/stores/options/action'
import useSession from 'tennders-auth/hooks/useSession'
import AppStorage from 'tennders-stracture/libs/storage'

let fetcingInitials = false

const selector = (state : StateType) => state.options.initials
interface ReturnType {
  countries: Record<string, any>[],
  internals: Record<string, any>[],
  truck_types: Record<string, any>[],
  constants: Record<string, any>,
  loading: boolean,
  boxOwner: Record<string, any>
}

const useInitials = () : ReturnType => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const data = useSelector(selector)
  const { user } = useSession()
  const setData = (initials) => dispatch(dispatchInitials(initials))

  const fetchInitials = async () => {
    if (fetcingInitials || data.countries.length) {
      return
    }
    setLoading(true)
    fetcingInitials = true
    // App initialization starts with this API
    const response = await apiGet(user ? '/general/initials' : '/external/company/initials')
    if (response) {
      setData({
        countries: [],
        internals: [],
        truck_types: [],
        ...response,
        constants: response.constants?.options ?? {}
      })
      AppStorage.saveToSessionStorage('truck_types', response?.truck_types)
      AppStorage.saveToSessionStorage('options', response?.constants?.options)
    }
    setLoading(false)
    fetcingInitials = false
  }

  useEffect(() => {
    fetchInitials()
  }, [])

  const { internals, constants, truck_types, countries, boxOwner } = data

  return {
    internals,
    constants,
    truck_types,
    countries,
    loading,
    boxOwner
  }
}

export default useInitials
